/*=========================================================================================
  File Name: rolesActions.js
  Description: Vuex Store - roles actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getActions({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/actions/' + payload.start,
                data: payload,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data.actions);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
